import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', path: '/' },
  { label: '短剧分类', path: '/category' },
  { label: '演员资料', path: '/actors' },
  { label: '影评专题', path: '/reviews' },
];

const infoLinks = [
  { label: '关于我们', path: '/about' },
  { label: '联系我们', path: '/contact' },
  { label: '搜索中心', path: '/search' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-accent-800/50 bg-accent-900 text-accent-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50 font-bold text-lg">
                <i className="ri-clapperboard-fill" />
              </span>
              <span className="text-lg font-bold text-background-50 font-heading tracking-wide">成人短剧</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-accent-200/80">
              成人短剧是一个聚焦成人向短篇影视剧的精选导览平台，提供剧集分类、剧情介绍、演员资料与深度影评，
              帮助 18 岁以上观众快速发现感兴趣的作品。全站内容均为虚构示例，用于产品演示。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-weibo-fill', 'ri-wechat-fill', 'ri-bookmark-2-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-800/70 text-accent-100 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-accent-200/80 hover:text-background-50 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">网站信息</h4>
            <ul className="space-y-2.5">
              {infoLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-accent-200/80 hover:text-background-50 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs leading-relaxed text-accent-300/70">
              <i className="ri-shield-check-line mr-1" />
              本站内容仅适合 18 岁以上用户浏览
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-accent-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-accent-300/70">© 2024 成人短剧 · 本网站为演示项目，所有内容均为虚构示例</p>
          <p className="text-xs text-accent-300/70">仅供学习与展示 · 请理性观影</p>
        </div>
      </div>
    </footer>
  );
}